import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background">
      <Helmet>
        <title>Seite nicht gefunden – Lasertag Siegen Highscores</title>
        <meta
          name="description"
          content="Diese Seite existiert nicht. Zurück zu den Live-Highscores der Lasertag Arena Siegen."
        />
        <meta name="robots" content="noindex, follow" />
        <link
          rel="canonical"
          href={`https://highscores.lasertag-arena-siegen.de${location.pathname}`}
        />
        <meta property="og:title" content="Seite nicht gefunden – Lasertag Siegen Highscores" />
        <meta
          property="og:description"
          content="Diese Seite existiert nicht. Zurück zu den Live-Highscores der Lasertag Arena Siegen."
        />
        <meta
          property="og:url"
          content={`https://highscores.lasertag-arena-siegen.de${location.pathname}`}
        />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Diese Seite gibt es nicht.</p>
        <a href="/" className="text-primary underline">
          Zurück zu den Highscores
        </a>
      </div>
    </main>
  );
};

export default NotFound;
